import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { useAuth } from '../hooks/useAuth';
import { useApiUrl } from '../hooks/useApiUrl'
import axios from 'axios';

type DeviceCapability = { supportsOverwrite: boolean };
const DeviceCapabilityContext = createContext<DeviceCapability>({ supportsOverwrite: false });

export const DeviceCapabilityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useAuth();
  const [cap, setCap] = useState<DeviceCapability>({ supportsOverwrite: false });
  const { buildDeviceUrl } = useApiUrl()
  const apiUrl = useApiUrl()
  useEffect(() => {
    if (!auth.deviceId) return;

    const run = async () => {
    try {
      const jwt = await auth.getJwt();
      if (!jwt) return;

      const headers = {
        ...axiosDefaultHeader,
        Authorization: `Bearer ${jwt}`,
      };

      let url: string;
      if (apiUrl.isDcp) {
        url =`${buildDeviceUrl(auth.deviceId,"/me/device-capabilitie")}`
      } else {
        url = `${baseUrl}${stage}/me/device-capabilities`;
      }
      const res = await axios.get(url, {
        headers,
        validateStatus: () => true,
      });
      console.log(`DeviceCapabilityProvider supportsOverwrite = ${res.data?.supportsOverwrite}`);
      setCap({ supportsOverwrite: !!res.data?.supportsOverwrite });
    } catch (e: any) {
        console.error('device-capabilities failed');
        console.error('message:', e?.message);
        console.error('code:', e?.code);
        console.error('response status:', e?.response?.status);
        console.error('response data:', e?.response?.data);
    }
  };

  run();
}, [auth.deviceId]);

  return <DeviceCapabilityContext.Provider value={cap}>{children}</DeviceCapabilityContext.Provider>;
};

export const useDeviceCapability = () => useContext(DeviceCapabilityContext);